export type ToolHandoffContinuationOutcome = 'succeeded' | 'failed';

interface ToolHandoffFinishState {
  isAbort: boolean;
  isDisconnect: boolean;
  isError: boolean;
}

interface PendingToolHandoffContinuation {
  resolve: (outcome: ToolHandoffContinuationOutcome) => void;
}

const pendingContinuations = new Map<string, PendingToolHandoffContinuation>();

export function beginToolHandoffContinuation(chatUuid: string): {
  outcome: Promise<ToolHandoffContinuationOutcome>;
  cancel: () => void;
} {
  if (pendingContinuations.has(chatUuid)) {
    throw new Error(`A tool handoff continuation is already active for chat ${chatUuid}.`);
  }

  let resolveOutcome: (outcome: ToolHandoffContinuationOutcome) => void = () => undefined;
  const outcome = new Promise<ToolHandoffContinuationOutcome>((resolve) => {
    resolveOutcome = resolve;
  });
  const pending = { resolve: resolveOutcome };
  pendingContinuations.set(chatUuid, pending);

  const settle = (result: ToolHandoffContinuationOutcome) => {
    if (pendingContinuations.get(chatUuid) !== pending) {
      return;
    }

    pendingContinuations.delete(chatUuid);
    pending.resolve(result);
  };

  return {
    outcome,
    cancel: () => settle('failed'),
  };
}

export function settleToolHandoffContinuation(chatUuid: string, finishState: ToolHandoffFinishState): void {
  const pending = pendingContinuations.get(chatUuid);
  if (!pending) {
    return;
  }

  pendingContinuations.delete(chatUuid);
  pending.resolve(finishState.isAbort || finishState.isDisconnect || finishState.isError ? 'failed' : 'succeeded');
}
